const serverOrigin = window.location.origin;
const serverFetch = (url: URL, options: RequestInit) => fetch(url, { ...options, credentials: 'same-origin' });

// Native HTTP can read the studio's uploads without requiring CORS on every
// image. A local object URL also keeps the drawing canvas exportable.
export async function readAnnotationImage(url: string, signal: AbortSignal): Promise<Blob> {
  const resolved = new URL(url, serverOrigin);
  const inlineImage = resolved.protocol === 'data:' && /^data:image\//i.test(url);
  if (!inlineImage && resolved.protocol !== 'blob:' && resolved.origin !== serverOrigin) throw new Error('Это изображение находится на другом сервере. Прикрепите его файлом.');
  const response = await (inlineImage ? fetch(resolved, { signal }) : serverFetch(resolved, { signal }));
  if (!response.ok) throw new Error('Не удалось загрузить изображение. Закройте редактор и попробуйте ещё раз.');
  const limit = 40 * 1024 * 1024;
  const tooLarge = () => new Error('Изображение больше 40 МБ. Для правок используйте уменьшенную копию.');
  if (Number(response.headers.get('Content-Length')) > limit) { await response.body?.cancel(); throw tooLarge(); }
  const reader = response.body?.getReader();
  if (!reader) throw new Error('Не удалось прочитать изображение.');
  const chunks: ArrayBuffer[] = []; let size = 0;
  while (true) {
    const { value, done } = await reader.read(); if (done) break;
    size += value.byteLength;
    if (size > limit) { await reader.cancel(); throw tooLarge(); }
    chunks.push(value.slice().buffer);
  }
  signal.throwIfAborted();
  return new Blob(chunks, { type: response.headers.get('Content-Type') || 'image/png' });
}
